import React from "react";
import moment from "moment";
import {
  Table, Button, Spin, Icon, Divider, Radio, message, InputNumber, Modal,
  Input, Tabs, Upload, Form, Card, Row, Col, DatePicker, Tag, TreeSelect, Select
} from 'antd';

import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import rosterService from '../../services/EmployeeManagement/roster-service.js';
import contractManagementService from '../../services/EmployeeManagement/contract-management-service.js';
import airticketAllowanceService from '../../services/SalaryAllowance/airticket-allowance-service.js';
import housingAllowanceService from '../../services/SalaryAllowance/housing-allowance-service.js';
import certificateManageService from '../../services/EmployeeManagement/certificate-manage-service.js';
import trackService from '../../services/EmployeeManagement/track-service.js';
import DynamicButton from "../../components/frame/DynamicButton";
import defaultPortrait from '../../assets/images/portrait.jpeg';
import { bool } from "prop-types";

@LayoutWrapper
@Form.create()
export default class EmployeeDetail extends React.Component {

  //readOnly = "yes" === sessionStorage.getItem("rosterReadOnly")
  readonly = true;
  hideButton = "yes" === sessionStorage.getItem("hideBackButton")

  state = {
    tab0: {},
    tab0Status: "unload",
    tab1: {},
    tab1Status: "unload",
    tab2: {},
    tab2Status: "unload",
    tab3: {},
    tab3Status: "unload",
    tab4: {},
    tab4Status: "unload",
    tab5: {},
    tab5Status: "unload",
    tab6: {},
    tab6Status: "unload",
    tab7: {},
    tab7Status: "unload",
    tab8: {},
    tab8Status: "unload",
    tab9: {},
    tab9Status: "unload",
    taba: {},
    tabaStatus: "unload",
    tabb: {},
    tabbStatus: "unload",
    tabc: {},
    tabcStatus: "unload",
    RewardAndPunishmentModal: false,
    user: {},
    tabIndex: "tab0",
    employee_id: "",
    savingTab0: false,
    savingTab1: false,
    savingTaba: false,
    tab5Filters: { page: 1 },
    tab8Filters: { page: 1 },
    tab9Filters: { page: 1 },
    triggeredPositions: [],
    isUploadingPortrait: false,

    certificatePreviewVisiable: false,
    certificatePreviewImage: "",
    isUploadingCertificateImage: false,
    disabled: false
  }

  componentWillMount() {
    const urlInfo = window.location.pathname.split("/");

    var disabled = window.location.search.replace('?', '').split('=');
    if (disabled[1] && disabled[1] === 'true') {
      this.setState({ disabled: true })
    }
    this.setState({
      employee_id: urlInfo.length === 4 ? urlInfo[3] : ""
    }, this.initializePage)
  }

  initializePage = () => {
    if(!this.props.access.roster.u_value){
      this.readOnly = 'yes'
    }
    if (this.state.employee_id) {
      this.realInitializePage[this.state.tabIndex]()
    } else {
      rosterService.fetchEmployeeInit({}, meta => {
        this.setState({
          tabIndex: "tab0",
          tab0Status: "loaded",
          meta: meta.data,
        })
      })
    }
  }
  backtoPrevious = () => window.history.go(-1)
  changeTabs = value => {
    const pageStatus = value + "Status"
    this.setState({
      [pageStatus]: this.state.employee_id ? "unload" : "loaded",
      tabIndex: value
    }, this.initializePage)
  }
  treeFindDepartmentPosition = (department_id, departments, positions) => {
    departments.forEach(department => {
      if (department.id === department_id) {
        positions.positions = department.positions
      } else if (department.children.length > 0) {
        this.treeFindDepartmentPosition(department_id, department.children, positions)
      }
    })
  }
  // services
  realInitializePage = {
    tab0: () => rosterService.fetchEmployeesDetail({ modelId: this.state.employee_id }, result => {
      console.log(result);
      rosterService.fetchEmployeeInit({}, meta => {
        console.log(meta)
        let positions = { positions: [] }
        this.treeFindDepartmentPosition(result.data.department_id, meta.data.departments, positions)
        this.setState({
          tab0Status: "loaded",
          triggeredPositions: positions.positions,
          meta: meta.data,
          tab0: result.data,
          user: {
            name: result.data.real_name,
            job_number: result.data.job_number
          }
        })
      })
    }),
    tab1: () => rosterService.fetchEmployeesDetail({ modelId: this.state.employee_id }, result => {
      rosterService.fetchEmployeeInit({}, meta => {
        this.setState({
          tab1Status: "loaded",
          meta: meta.data,
          tab1: result.data
        })
      })
    }),
    tabc: () => rosterService.fetchEmployeeChilds({ employee_id: this.state.employee_id }, result => {
      console.log(123);
      console.log(result);
      this.setState({
        tabcStatus: "loaded",
        tabc: { childs: result.data.Data }
      })
    }),
    tab2: () => contractManagementService.fetchContractDetail(this.state.employee_id, result => {
      console.log(result);
      this.setState({
        tab2Status: "loaded",
        tab2: result.data
      })
    }),
    tab3: () => rosterService.selectEmployeeEducation({ employee_id: this.state.employee_id }, result => {
      console.log(result);
      this.setState({
        tab3Status: "loaded",
        tab3: { educations: result.data.Object.Data }
      })
    }),
    tab4: () => rosterService.selectEmployeeExperience({ employee_id: this.state.employee_id }, result => {
      console.log(result);
      this.setState({
        tab4Status: "loaded",
        tab4: { experiences: result.data.Object.Data }
      })
    }),
    tab5: () => rosterService.selectEmployeeTrack({ employee_id: this.state.employee_id }, result => {
      console.log(result);
      this.setState({
        tab5Status: "loaded",
        tab5: { Data: result.data.Object }
      })
    }),
    tab6: () => certificateManageService.fetchCertificateList({
      employee_id: this.state.employee_id,
      PageSize: 9999
    }, result => {
      console.log(result);
      rosterService.fetchEmployeeInit({}, meta => {
        this.setState({
          tab6Status: "loaded",
          tab6: {
            certificates: result.data.Data,
            meta: meta.data
          }
        })
      })
    }),
    tab7: () => {
      rosterService.selectEmployeeTraining({ employee_id: this.state.employee_id }, result => {
        // console.log(result)
        this.setState({
          tab7Status: "loaded",
          tab7: {
            foundations: result.data.Data
          }
        })
      })
    },
    tab8: () => airticketAllowanceService.selectAirticketAllowance({
      employee_id: this.state.employee_id,
      page: this.state.tab8Filters.page
    }, result => {
      console.log(result);
      this.setState({
        tab8Status: "loaded",
        tab8: result.data.Object
      })
    }),
    tab9: () => housingAllowanceService.selectHousingAllowance({
      employee_id: this.state.employee_id,
      page: this.state.tab9Filters.page
    }, result => {
      console.log(result);
      this.setState({
        tab9Status: "loaded",
        tab9: result.data.Object
      })
    }),
    taba: () => rosterService.selectEmployeeInsure({ employee_id: this.state.employee_id }, result => {
      // console.log(result)
      this.setState({
        tabaStatus: "loaded",
        taba: { insurance: result.data.Object }
      })
    }),
    tabb: () => rosterService.selectEmployeeHoliday({ employee_id: this.state.employee_id }, result => {
      console.log(result)
      this.setState({
        tabbStatus: "loaded",
        tabb: {
          holiday: [{
            title: "年假(天)",
            key1: result.data.Object.last_annual_left,
            key2: result.data.Object.annual_left,
            key3: result.data.Object.annual_available
          }, {
            title: "调休(小时)",
            key1: result.data.Object.last_common_relax_left,
            key2: result.data.Object.common_relax_left,
            key3: result.data.Object.common_relax_available
          }, {
            title: "因公调休(小时)",
            key1: result.data.Object.last_formal_relax_left,
            key2: result.data.Object.formal_relax_left,
            key3: result.data.Object.formal_relax_available
          }
          ]
        }
      })
    })
  }
  // tab0
  beforeUpload = file => {
    const typeCheck = "image/jpeg" === file.type || "image/png" === file.type
    if (!typeCheck) {
      message.error("请上传合法的PNG或者JPEG图片!", 4)
    }
    const sizeCheck = file.size < 2 * 1024 * 1024
    if (!sizeCheck) {
      message.error("上传图片的大小不能超过2M!", 4)
    }
    return typeCheck && sizeCheck;
  }
  uploadPortrait = event => {
    const formData = new FormData();
    formData.append("uploadedFile", event.file)
    this.setState({
      isUploadingPortrait: true
    }, () => rosterService.uploadEmployeeAvatar(formData, result => {
      console.log(result)
      this.setState({ isUploadingPortrait: false })
      if (result.data.Success) {
        this.setState({
          tab0: {
            ...this.state.tab0,
            head_image: result.data.Object
          }
        })
      }
    }, error => {
      message.error("上传图片出错", 4)
      this.setState({ isUploadingPortrait: false })
    }))
  }
  renderTreeNodes = data => data.map(item => {
    if (item.children) {
      return (
        <TreeSelect.TreeNode title={item.name}
          value={item.id}
          key={item.id}
          dataRef={item} >
          {item.children.length !== 0 && this.renderTreeNodes(item.children)}
        </TreeSelect.TreeNode>
      )
    }
    return <TreeSelect.TreeNode {...item} />
  })
  setDepartmentFilter = (id, value, event) => {
    this.props.form.setFieldsValue({ "position_id": "" })
    this.props.form.setFieldsValue({ "business_name": "" })
    this.props.form.setFieldsValue({ "business_level": "" })
    const positions = event.triggerNode ? event.triggerNode.props.dataRef.positions : []
    this.setState({ triggeredPositions: positions })
  }
  setPositionFilter = (value, event) => {
    this.props.form.setFieldsValue({ "business_name": event ? event.props.dataRef.business_name : "" })
    this.props.form.setFieldsValue({ "business_level": event ? event.props.dataRef.business_level : "" })
  }
  submitBasicInformation = () => this.props.form.validateFields((err, values) => {
    if (err) {
      return
    }
    let post = {
      ...this.state.tab0,
      ...values,
      entry_date: values.entry_date.format("YYYY-MM-DD"),
      birthday: values.birthday.format("YYYY-MM-DD")
    }
    // console.log(post)
    if (post.id) {
      rosterService.editEmployee(post, result => {
        if (result.data.Success) {
          message.success("编辑用户基本信息成功", 4)
        } else {
          message.error("编辑用户基本信息失败, " + result.data.Errors[0], 4)
        }
      }, error => message.error("编辑用户信息失败", 4))
    } else {
      rosterService.createEmployee(post, result => {
        if (result.data.Success) {
          message.success("创建用户基本信息成功", 4)
          this.setState({ employee_id: result.data.ModelId })
          // this.props.history.push("/employee/detail/" + result.data.ModelId)
        } else {
          message.error("创建用户基本信息失败, " + result.data.Errors[0], 4)
        }
      }, error => message.error("编辑用户信息失败", 4))
    }
  })
  // tab1
  submitDetailInformation = () => this.props.form.validateFields((err, values) => {
    let post = {
      ...this.state.tab1,
      ...values
    }
    console.log(post);
    rosterService.updateEmployeeDetail(post, result => {
      if (result.data.Success) {
        message.success("编辑用户详细信息成功", 4)
      } else {
        message.error("编辑用户详细信息失败, " + result.data.Errors[0], 4)
      }
    }, error => message.error("编辑用户详细信息失败", 4))
  })
  // tab2
  createContractItem = () => this.setState({
    tab2: {
      ...this.state.tab2,
      contracts: [
        {
          property_id: "",
          status_id: "",
          type_id: "",
          start_date: "",
          end_date: "",
          employee_id: this.state.employee_id
        },
        ...this.state.tab2.contracts
      ]
    }
  })
  deleteContract = index => {
    if (this.state.tab2.contracts[index].id) {
      Modal.confirm({
        title: '确定要删除这条记录么?',
        onOk: () => {
          contractManagementService.deleteContract(this.state.tab2.contracts[index], result => {
            // console.log(result)
            if (result.data.Success) {
              message.success("删除合同成功", 4)
              this.initializePage();
            } else {
              message.error("删除合同失败, " + result.data.Errors[0], 4)
            }
          }, error => {
            message.error("删除合同失败", 4)
          })
        },
        onCancel: () => { }
      });
    } else {
      this.viewDeleteContract(index)
    }
  }
  viewDeleteContract = index => this.setState({
    tab2: {
      ...this.state.tab2,
      contracts: [
        ...this.state.tab2.contracts.slice(0, index),
        ...this.state.tab2.contracts.slice(index + 1)
      ]
    }
  })
  changeContract = (index, column, event) =>{
    this.setState({
      tab2: {
        ...this.state.tab2,
        contracts: [
          ...this.state.tab2.contracts.slice(0, index),
          {
            ...this.state.tab2.contracts[index],
            [column]:column=="signed_company"?event:event.target.value
          },
          ...this.state.tab2.contracts.slice(index + 1)
        ]
      }
    })
  }
  changeContractDate = (index, column, moment) => this.setState({
    tab2: {
      ...this.state.tab2,
      contracts: [
        ...this.state.tab2.contracts.slice(0, index),
        {
          ...this.state.tab2.contracts[index],
          [column]: moment ? moment.format("YYYY-MM-DD") : null
        },
        ...this.state.tab2.contracts.slice(index + 1)
      ]
    }
  })
  submitContract = index => {
    if (this.state.tab2.contracts[index].id) {
      this.updateContract(index)
    } else {
      this.createContract(index)
    }
  }
  createContract = index => contractManagementService.addContract(this.state.tab2.contracts[index], result => {
    // console.log(result)
    if (result.data.Success) {
      message.success("创建合同成功", 4)
      this.initializePage()
    } else {
      message.error("创建合同失败, " + result.data.Errors[0], 4)
    }
  }, error => message.error("创建合同失败", 4))
  updateContract = index => contractManagementService.editContract(this.state.tab2.contracts[index], result => {
    // console.log(result)
    if (result.data.Success) {
      message.success("修改合同成功", 4)
    } else {
      message.error("修改合同失败, " + result.data.Errors[0], 4)
    }
  }, error => message.error("修改合同失败", 4))

  // tab3
  createEducationItem = () => this.setState({
    tab3: {
      ...this.state.tab3,
      educations: [
        {
          school_name: "",
          major: "",
          entry_date: "",
          completion_date: "",
          get_degree: true,
          education_experience: "",
          employee_id: this.state.employee_id
        },
        ...this.state.tab3.educations
      ]
    }
  })
  deleteEducation = index => {
    if (this.state.tab3.educations[index].id) {
      Modal.confirm({
        title: '确定要删除这条记录么?',
        onOk: () => {
          rosterService.deleteEmployeeEducation(this.state.tab3.educations[index], result => {
            // console.log(result)
            if (result.data.Success) {
              message.success("删除教育信息成功", 4)
              this.initializePage();
            } else {
              message.error("删除教育信息失败, " + result.data.Errors[0], 4)
            }
          }, error => message.error("删除教育信息失败", 4))
        },
        onCancel: () => { }
      });
    } else {
      this.viewDeleteEducation(index)
    }
  }
  viewDeleteEducation = index => this.setState({
    tab3: {
      ...this.state.tab3,
      educations: [
        ...this.state.tab3.educations.slice(0, index),
        ...this.state.tab3.educations.slice(index + 1)
      ]
    }
  })
  changeEducation = (index, column, event) => this.setState({
    tab3: {
      ...this.state.tab3,
      educations: [
        ...this.state.tab3.educations.slice(0, index),
        {
          ...this.state.tab3.educations[index],
          [column]: event.target.value
        },
        ...this.state.tab3.educations.slice(index + 1)
      ]
    }
  })
  changeEducationDate = (index, column, moment) => this.setState({
    tab3: {
      ...this.state.tab3,
      educations: [
        ...this.state.tab3.educations.slice(0, index),
        {
          ...this.state.tab3.educations[index],
          [column]: moment ? moment.format("YYYY-MM-DD") : null
        },
        ...this.state.tab3.educations.slice(index + 1)
      ]
    }
  })
  submitEducation = index => {
    if (this.state.tab3.educations[index].id) {
      this.updateEducation(index)
    } else {
      this.createEducation(index)
    }
  }
  createEducation = index => rosterService.createEmployeeEducation(this.state.tab3.educations[index], result => {
    // console.log(result)
    if (result.data.Success) {
      message.success("创建教育经历成功", 4)
      this.initializePage()
    } else {
      message.error("创建教育经历失败, " + result.data.Errors[0], 4)
    }
  }, error => message.error("创建教育经历失败", 4))
  updateEducation = index => rosterService.updateEmployeeEducation(this.state.tab3.educations[index], result => {
    // console.log(result)
    if (result.data.Success) {
      message.success("修改教育经历成功", 4)
    } else {
      message.error("修改教育经历失败, " + result.data.Errors[0], 4)
    }
  }, error => message.error("修改教育经历失败", 4))

  // tab4
  createExperienceItem = () => this.setState({
    tab4: {
      ...this.state.tab4,
      experiences: [
        {
          company_name: "",
          position: "",
          entry_date: "",
          leave_date: "",
          position_description: "",
          employee_id: this.state.employee_id
        },
        ...this.state.tab4.experiences
      ]
    }
  })

  // tabc
  createChildDetail = () => this.setState({
    tabc: {
      ...this.state.tabc,
      childs: [
        {
          name: "",
          english_name: "",
          birthday: "",
          gender: "",
          age: "",
          employee_id: this.state.employee_id
        },
        ...this.state.tabc.childs
      ]
    }
  })

  deleteExperience = index => {
    if (this.state.tab4.experiences[index].id) {
      Modal.confirm({
        title: '确定要删除这条记录么?',
        onOk: () => {
          rosterService.deleteEmployeeExperience(this.state.tab4.experiences[index], result => {
            // console.log(result)
            if (result.data.Success) {
              message.success("删除工作经历成功", 4)
              this.initializePage();
            } else {
              message.error("删除工作经历失败, " + result.data.Errors[0], 4)
            }
          }, error => message.error("删除工作经历失败", 4))
        },
        onCancel: () => { }
      });
    } else {
      this.viewDeleteExperience(index)
    }
  }

  deleteChild = index => {
    if (this.state.tabc.childs[index].id) {
      Modal.confirm({
        title: '确定要删除这条记录么?',
        onOk: () => {
          rosterService.deleteChild(this.state.tabc.childs[index], result => {
            // console.log(result)
            if (result.data.Success) {
              message.success("删除成功", 4)
              this.initializePage();
            } else {
              message.error("删除失败, " + result.data.Errors[0], 4)
            }
          }, error => message.error("删除失败", 4))
        },
        onCancel: () => { }
      });
    } else {
      this.viewDeleteChild(index)
    }
  }

  viewDeleteExperience = index => this.setState({
    tab4: {
      ...this.state.tab4,
      experiences: [
        ...this.state.tab4.experiences.slice(0, index),
        ...this.state.tab4.experiences.slice(index + 1)
      ]
    }
  })
  viewDeleteChild = index => this.setState({
    tabc: {
      ...this.state.tabc,
      childs: [
        ...this.state.tabc.childs.slice(0, index),
        ...this.state.tabc.childs.slice(index + 1)
      ]
    }
  })

  changeExperience = (index, column, event) => this.setState({
    tab4: {
      ...this.state.tab4,
      experiences: [
        ...this.state.tab4.experiences.slice(0, index),
        {
          ...this.state.tab4.experiences[index],
          [column]: event.target.value
        },
        ...this.state.tab4.experiences.slice(index + 1)
      ]
    }
  })


  changeChild = (index, column, event) => this.setState({
    tabc: {
      ...this.state.tabc,
      childs: [
        ...this.state.tabc.childs.slice(0, index),
        {
          ...this.state.tabc.childs[index],
          [column]: event.target.value
        },
        ...this.state.tabc.childs.slice(index + 1)
      ]
    }
  })

  changeExperienceDate = (index, column, moment) => this.setState({
    tab4: {
      ...this.state.tab4,
      experiences: [
        ...this.state.tab4.experiences.slice(0, index),
        {
          ...this.state.tab4.experiences[index],
          [column]: moment ? moment.format("YYYY-MM-DD") : null
        },
        ...this.state.tab4.experiences.slice(index + 1)
      ]
    }
  })
  changeChildBirthday = (index, column, moment) => this.setState({
    tabc: {
      ...this.state.tabc,
      childs: [
        ...this.state.tabc.childs.slice(0, index),
        {
          ...this.state.tabc.childs[index],
          [column]: moment ? moment.format("YYYY-MM-DD") : null
        },
        ...this.state.tabc.childs.slice(index + 1)
      ]
    }
  })

  submitExperience = index => {
    if (this.state.tab4.experiences[index].id) {
      this.updateExperience(index)
    } else {
      this.createExperience(index)
    }
  }

  submitChild = index => {
    if (this.state.tabc.childs[index].id) {
      this.updateChild(index)
    } else {
      this.createChild(index)
    }
  }

  createExperience = index => rosterService.createEmployeeExperience(this.state.tab4.experiences[index], result => {
    // console.log(result)
    if (result.data.Success) {
      message.success("创建工作经历成功", 4)
      this.initializePage()
    } else {
      message.error("创建工作经历失败, " + result.data.Errors[0], 4)
    }
  }, error => message.error("创建工作经历失败", 4))
  updateExperience = index => rosterService.updateEmployeeExperience(this.state.tab4.experiences[index], result => {
    // console.log(result)
    if (result.data.Success) {
      message.success("修改工作经历成功", 4)
    } else {
      message.error("修改工作经历失败, " + result.data.Errors[0], 4)
    }
  }, error => message.error("修改工作经历失败", 4))

  createChild = index => rosterService.createChild(this.state.tabc.childs[index], result => {
    // console.log(result)
    if (result.data.Success) {
      message.success("创建成功", 4)
      this.initializePage()
    } else {
      message.error("创建失败, " + result.data.Errors[0], 4)
    }
  }, error => message.error("创建失败", 4))

  updateChild = index => rosterService.updateChild(this.state.tabc.childs[index], result => {
    // console.log(result)
    if (result.data.Success) {
      message.success("修改成功", 4)
    } else {
      message.error("修改失败, " + result.data.Errors[0], 4)
    }
  }, error => message.error("修改失败", 4))


  // tab5
  detailButtonColumn = (text, record, index) => [{
    size: "small",
    type: "default",
    icon: "delete",
    title: "删除",
    access: "d_value",
    click: this.deleteData.bind(this, record, index),
}]
deleteData = (record, index) => {
  Modal.confirm({
      title: '确定删除选中的内容么?',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
          let data = {
              ids: [record.id]
          };
          rosterService
              .deleteEmployeeTrack(data, res => {
                  if (res.data.Success) {
                      message.success('删除操作成功', 4);
                      this.realInitializePage['tab5']()

                  } else {
                      message.error('删除操作失败' + res.data.Errors[0], 4);
                  }
              }, err => message.error('删除操作失败, 请联系管理员'));
      },
      onCancel: () => { }
  });

}
  footmarkColumn = [{
    title: '时间',
    dataIndex: 'employee_track_time',
    key: 'employee_track_time',
    className: 'table-global-head-6x'
  }, {
    title: '类型',
    dataIndex: 'employee_track_type',
    key: 'employee_track_type',
    className: 'table-global-head-6x'
  }, {
    title: "详情",
    dataIndex: 'employee_track_description',
    key: 'employee_track_description',
    className: 'table-global-head-12x'
  },  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    className: 'table-global-head-small',
    render: (text, record, index) => (
        <DynamicButton column={this.detailButtonColumn(text, record, index)} />
    )
}
  ]

  setFootmarkPageFilter = paginition => this.setState({
    tab5Filters: {
      ...this.state.tab5Filters,
      page: paginition.current
    }
  }, this.initializePage)

  // tab6
  createCertificateItem = () => this.setState({
    tab6: {
      ...this.state.tab6,
      certificates: [
        {
          title: "",
          employee_id: this.state.employee_id,
          images: []
        },
        ...this.state.tab6.certificates
      ]
    }
  })
  deleteCertificate = index => {
    if (this.state.tab6.certificates[index].id) {
      Modal.confirm({
        title: '确定要删除这条记录么?',
        onOk: () => {
          const deleteData = {
            ids: [this.state.tab6.certificates[index].id]
          }
          certificateManageService.deleteCertificate(deleteData, result => {
            // console.log(result)
            if (result.data.Success) {
              message.success("删除员工证照成功", 4)
              this.initializePage();
            } else {
              message.error("删除员工证照失败, " + result.data.Errors[0], 4)
            }
          }, error => message.error("删除员工证照失败", 4))
        },
        onCancel: () => { }
      });
    } else {
      this.viewDeleteCertificate(index)
    }
  }
  viewDeleteCertificate = index => this.setState({
    tab6: {
      ...this.state.tab6,
      certificates: [
        ...this.state.tab6.certificates.slice(0, index),
        ...this.state.tab6.certificates.slice(index + 1)
      ]
    }
  })
  changeCertificate = (index, column, event) => this.setState({
    tab6: {
      ...this.state.tab6,
      certificates: [
        ...this.state.tab6.certificates.slice(0, index),
        {
          ...this.state.tab6.certificates[index],
          [column]: event.target.value
        },
        ...this.state.tab6.certificates.slice(index + 1)
      ]
    }
  })
  changeCertificateData = (index, column, value) => this.setState({
    tab6: {
      ...this.state.tab6,
      certificates: [
        ...this.state.tab6.certificates.slice(0, index),
        {
          ...this.state.tab6.certificates[index],
          [column]: value
        },
        ...this.state.tab6.certificates.slice(index + 1)
      ]
    }
  })
  changeCertificateDate = (index, column, moment) => this.setState({
    tab6: {
      ...this.state.tab6,
      certificates: [
        ...this.state.tab6.certificates.slice(0, index),
        {
          ...this.state.tab6.certificates[index],
          [column]: moment ? moment.format("YYYY-MM-DD") : null
        },
        ...this.state.tab6.certificates.slice(index + 1)
      ]
    }
  })
  submitCertificate = index => {
    if (this.state.tab6.certificates[index].id) {
      this.updateCertificate(index)
    } else {
      this.createCertificate(index)
    }
  }
  createCertificate = index => certificateManageService.createCertificate(this.state.tab6.certificates[index], result => {
    // console.log(result)
    if (result.data.Success) {
      message.success("创建员工证照成功", 4)
      this.initializePage()
    } else {
      message.error("创建员工证照失败, " + result.data.Errors[0], 4)
    }
  }, error => message.error("创建员工证照失败", 4))
  updateCertificate = index => certificateManageService.updateCertificate(this.state.tab6.certificates[index], result => {
    // console.log(result)
    if (result.data.Success) {
      message.success("修改员工证照成功", 4)
    } else {
      message.error("修改员工证照失败, " + result.data.Errors[0], 4)
    }
  }, error => message.error("修改员工证照失败", 4))

  previewCertificate = image => this.setState({
    certificatePreviewVisiable: true,
    certificatePreviewImage: image.photo_path
  })

  toggleCertificatePreviewModal = () => this.setState({
    certificatePreviewVisiable: !this.state.certificatePreviewVisiable
  })

  uploadCertificateImage = (certificateIndex, event) => {
    console.log(event.file)
    const formData = new FormData();
    formData.append("uploadedFile", event.file)
    // formData.append("employee_id", this.state.employee_id)
    this.setState({
      isUploadingCertificateImage: true
    }, () => rosterService.uploadCertificateImage(formData, result => {
      console.log(result)
      if (result.data.Success) {
        this.setState({
          isUploadingCertificateImage: false,
          tab6: {
            ...this.state.tab6,
            certificates: [
              ...this.state.tab6.certificates.slice(0, certificateIndex),
              {
                ...this.state.tab6.certificates[certificateIndex],
                images: [
                  ...this.state.tab6.certificates[certificateIndex].images,
                  {
                    uid: event.file.uid,
                    photo_path: result.data.Object
                  }
                ]
              },
              ...this.state.tab6.certificates.slice(certificateIndex + 1)
            ]
          }
        })
      } else {
        this.setState({
          isUploadingCertificateImage: false
        })
        message.error("上传证件照片 " + event.file.name + " 出错, " + result.data.Errors[0], 4)
      }
    }, error => {
      this.setState({ isUploadingCertificateImage: false })
      message.error("上传证件照片出错", 4)
    }))
  }

  removeCertificate = (certificateIndex, image) => {
    const imageIndex = this.state.tab6.certificates[certificateIndex].images.map(image => image.id).indexOf(image.id)
    this.setState({
      tab6: {
        ...this.state.tab6,
        certificates: [
          ...this.state.tab6.certificates.slice(0, certificateIndex),
          {
            ...this.state.tab6.certificates[certificateIndex],
            images: [
              ...this.state.tab6.certificates[certificateIndex].images.slice(0, imageIndex),
              ...this.state.tab6.certificates[certificateIndex].images.slice(imageIndex + 1)
            ]
          },
          ...this.state.tab6.certificates.slice(certificateIndex + 1)
        ]
      }
    })
  }

  // tab7
  createFoundationItem = () => this.setState({
    tab7: {
      ...this.state.tab7,
      foundations: [
        {
          title: "",
          url: "https://avatars2.githubusercontent.com/u/32281479?s=40&v=4",
          employee_id: this.state.employee_id
        },
        ...this.state.tab7.foundations
      ]
    }
  })
  deleteFoundation = index => {
    if (this.state.tab7.foundations[index].id) {
      Modal.confirm({
        title: '确定要删除这条记录么?',
        onOk: () => {
          rosterService.deleteEmployeeTraining(this.state.tab7.foundations[index], result => {
            // console.log(result)
            if (result.data.Success) {
              message.success("删除培训基金成功", 4)
              this.initializePage();
            } else {
              message.error("删除培训基金失败, " + result.data.Errors[0], 4)
            }
          }, error => message.error("删除培训基金失败", 4))
        },
        onCancel: () => { }
      })
    } else {
      this.viewDeleteFoundation(index)
    }
  }
  viewDeleteFoundation = index => this.setState({
    tab7: {
      ...this.state.tab7,
      foundations: [
        ...this.state.tab7.foundations.slice(0, index),
        ...this.state.tab7.foundations.slice(index + 1)
      ]
    }
  })
  changeFoundation = (index, column, event) => this.setState({
    tab7: {
      ...this.state.tab7,
      foundations: [
        ...this.state.tab7.foundations.slice(0, index),
        {
          ...this.state.tab7.foundations[index],
          [column]: event.target.value
        },
        ...this.state.tab7.foundations.slice(index + 1)
      ]
    }
  })
  changeFoundationData = (index, column, value) => this.setState({
    tab7: {
      ...this.state.tab7,
      foundations: [
        ...this.state.tab7.foundations.slice(0, index),
        {
          ...this.state.tab7.foundations[index],
          [column]: value
        },
        ...this.state.tab7.foundations.slice(index + 1)
      ]
    }
  })
  changeFoundationDate = (index, column, moment) => this.setState({
    tab7: {
      ...this.state.tab7,
      foundations: [
        ...this.state.tab7.foundations.slice(0, index),
        {
          ...this.state.tab7.foundations[index],
          [column]: moment ? moment.format("YYYY-MM-DD") : null
        },
        ...this.state.tab7.foundations.slice(index + 1)
      ]
    }
  })
  submitFoundation = index => {
    if (this.state.tab7.foundations[index].id) {
      this.updateFoundation(index)
    } else {
      this.createFoundation(index)
    }
  }
  createFoundation = index => rosterService.createEmployeeTraining(this.state.tab7.foundations[index], result => {
    // console.log(result)
    if (result.data.Success) {
      message.success("创建培训基金成功", 4)
      this.initializePage()
    } else {
      message.error("创建培训基金失败, " + result.data.Errors[0], 4)
    }
  }, error => message.error("创建培训基金失败", 4))
  updateFoundation = index => rosterService.updateEmployeeTraining(this.state.tab7.foundations[index], result => {
    // console.log(result)
    if (result.data.Success) {
      message.success("修改培训基金成功", 4)
      this.initializePage()
    } else {
      message.error("修改培训基金失败, " + result.data.Errors[0], 4)
    }
  }, error => message.error("修改培训基金失败", 4))

  // tab8
  airticketColumn = [{
    title: '补贴年份',
    dataIndex: 'subsidy_year',
    key: 'subsidy_year',
    className: 'table-global-head-short'
  }, {
    title: '补贴总金额',
    dataIndex: 'subsidy_total_amount',
    key: 'subsidy_total_amount',
    className: 'table-global-head-6x'
  }, {
    title: '补贴金额',
    dataIndex: 'subsidy_amount',
    key: 'subsidy_amount',
    className: 'table-global-head-short'
  }, {
    title: '剩余补贴金额',
    dataIndex: 'subsidy_surplus_amount',
    key: 'subsidy_surplus_amount',
    className: 'table-global-head',
    render: (text, record) => record.subsidy_total_amount - record.subsidy_amount
  }, {
    title: '发放月份',
    dataIndex: 'release_month',
    key: 'release_month',
    className: 'table-global-head-short'
  }
  ]

  setAirticketPageFilter = paginition => this.setState({
    tab8Filters: {
      ...this.state.tab8Filters,
      page: paginition.current
    }
  }, this.initializePage)

  // tab9
  housingColumn = [{
    title: '开始时间',
    dataIndex: 'start_time',
    key: 'start_time',
    className: 'table-global-head-short'
  }, {
    title: '结束时间',
    dataIndex: 'end_time',
    key: 'end_time',
    className: 'table-global-head-short'
  }, {
    title: '补贴金额',
    dataIndex: 'subsidy_amount',
    key: 'subsidy_amount',
    className: 'table-global-head-small'
  }
  ]

  setHousingPageFilter = paginition => this.setState({
    tab9Filters: {
      ...this.state.tab9Filters,
      page: paginition.current
    }
  }, this.initializePage)

  // taba
  changeInsurance = (column, value) => this.setState({
    taba: {
      ...this.state.taba,
      insurance: {
        ...this.state.taba.insurance,
        [column]: value
      }
    }
  })
  changeInsuranceSettings = (column, event) => this.setState({
    taba: {
      ...this.state.taba,
      insurance: {
        ...this.state.taba.insurance,
        [column]: event.target.value
      }
    }
  })
  submitInsureInformation = () => {
    const put = {
      employee_id: this.state.employee_id,
      ...this.state.taba.insurance
    }
    rosterService.updateEmployeeInsure(put, result => {
      // console.log(result)
      if (result.data.Success) {
        message.success("保存社保信息成功", 4)
      } else {
        message.error("保存社保信息失败, " + result.data.Errors[0], 4)
      }
    }, error => message.error("保存社保信息失败", 4))
  }
  // tabb
  holidayColumn = [{
    title: '项目',
    dataIndex: 'title',
    key: 'title',
    className: 'table-global-head-small'
  }, {
    title: '上年(月)结余',
    dataIndex: 'key1',
    key: 'key1',
    className: 'table-global-head-small'
  }, {
    title: '本年(月)剩余',
    dataIndex: 'key2',
    key: 'key2',
    className: 'table-global-head-small'
  }, {
    title: '当前可用',
    dataIndex: 'key3',
    key: 'key3',
    className: 'table-global-head-small'
  }
  ]

  render() {
    return (
      <div className="app-module-item">
        <div style={{ float: "left" }}>
          {!this.hideButton &&
            <Button icon="arrow-left" style={{ margin: "0px 5px 10px 0px" }}
              onClick={this.backtoPrevious}>
              返回
          </Button>}
          {this.state.employee_id &&
            <span style={{ fontWeight: "bold", margin: "0px 0px 0px 20px", fontSize: "1.2em" }}>
              {this.state.user.name && this.state.user.job_number &&
                <span>
                  <span>用户:&nbsp;&nbsp;</span>
                  <span>{this.state.user.name}</span>
                  <span>&nbsp;&lt;&nbsp;工号:&nbsp;</span>
                  <span>{this.state.user.job_number}</span>
                  <span>&nbsp;&gt;&nbsp;信息详情</span>
                </span>}
            </span>
          }
          {!this.state.employee_id &&
            <span style={{ fontWeight: "bold", margin: "0px 0px 0px 20px", fontSize: "1.2em" }}>创建新用户</span>
          }
        </div>
        <div style={{ clear: "both" }}></div>
        <Divider style={{ margin: "7px 0px 10px" }} />
        <div id="roster-content" style={{ paddingBottom: "10px", minHeight: "640px" }}>
          <Tabs onChange={this.changeTabs} type="card">
            <Tabs.TabPane tab="基本信息 Basic info" key="tab0">
              {"loaded" === this.state.tab0Status && "tab0" === this.state.tabIndex &&
                <div>
                  {!this.readOnly  &&
                    <div>
                      <Button type="primary" onClick={this.submitBasicInformation} >
                        <Icon type="save" theme="outlined" />
                        <span>保存信息 Save info</span>
                      </Button>
                    </div>}
                  <div style={{ overflowX: "auto" }}>
                    <div style={{ width: "1102px", margin: "15px 0px 0px" }}>
                      <div style={{ width: "300px", padding: "0px 15px", float: "left" }} className="roster-left-content">
                        <Upload name="avatar"
                          disabled={this.readOnly || this.state.isUploadingPortrait}
                          listType="picture-card"
                          showUploadList={false}
                          beforeUpload={this.beforeUpload}
                          customRequest={this.uploadPortrait}>
                          <img src={this.state.tab0.head_image ? this.state.tab0.head_image : defaultPortrait}
                            alt="avatar"
                            style={{ width: "252px", height: "252px" }} />
                        </Upload>
                        <div>
                          <Form.Item label="中文名">
                            {this.props.form.getFieldDecorator("real_name", {
                              rules: [{ required: true, message: '请输入中文名' }],
                              initialValue: this.state.tab0.real_name
                            })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div>
                        <div>
                          <Form.Item label="英文名">
                            {this.props.form.getFieldDecorator("english_name", {
                              rules: [{ required: true, message: '请输入英文名' }],
                              initialValue: this.state.tab0.english_name
                            })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div>
                        <div>
                          <Form.Item label="性别">
                            {this.props.form.getFieldDecorator("gender", {
                              rules: [{ required: true, message: '请选择性别' }],
                              initialValue: this.state.tab0.gender
                            })(
                              <Radio.Group disabled={this.readOnly} buttonStyle="solid">
                                <Radio.Button value="男">男</Radio.Button>
                                <Radio.Button value="女">女</Radio.Button>
                              </Radio.Group>
                            )}
                          </Form.Item>
                        </div>
                      </div>
                      <div style={{ float: "left", width: "800px" }}>
                        <Form layout="inline">
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="工号">
                              {this.props.form.getFieldDecorator("job_number", {
                                rules: [{ required: true, message: '请输入工号' }],
                                initialValue: this.state.tab0.job_number
                              })(<Input disabled={this.readOnly||this.state.disabled} style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="入职日期">
                              {this.props.form.getFieldDecorator("entry_date", {
                                rules: [{ required: true, message: "请输入入职日期" }],
                                initialValue: this.state.tab0.entry_date ? moment(this.state.tab0.entry_date) : null
                              })(<DatePicker disabled={this.readOnly||this.state.disabled} style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="校区">
                              {this.props.form.getFieldDecorator("campus", {
                                rules: [{ required: true, message: '请输入校区' }],
                                initialValue: this.state.tab0.campus
                              })(
                                <Select style={{ width: "270px" }} disabled={this.readOnly||this.state.disabled} allowClear>
                                  <Select.Option key='华山校HS' value='华山校HS'>{'华山校HS'}</Select.Option>
                                  <Select.Option key='中星城校ZXC' value='中星城校ZXC'>{'中星城校ZXC'}</Select.Option>
                                  <Select.Option key='时光里校SGL' value='时光里校SGL'>{'时光里校SGL'}</Select.Option>
                                  <Select.Option key='晶耀前滩校JYC' value='晶耀前滩校JYC'>{'晶耀前滩校JYC'}</Select.Option>

                                </Select>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="部门">
                              {this.props.form.getFieldDecorator("department_id", {
                                rules: [{ required: true, message: '请输入部门' }],
                                initialValue: this.state.tab0.department_id
                              })(
                                <TreeSelect style={{ width: "270px" }}
                                  allowClear
                                  disabled={this.readOnly||this.state.disabled}
                                  placeholder="请选择部门"
                                  showSearch={false}
                                  autoExpandParent={true}
                                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                  treeDefaultExpandAll
                                  onChange={this.setDepartmentFilter}>
                                  {this.renderTreeNodes(this.state.meta.departments)}
                                </TreeSelect>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="职位">
                              {this.props.form.getFieldDecorator("position_id", {
                                rules: [{ required: true, message: '请选择职位' }],
                                initialValue: this.state.tab0.position_id
                              })(
                                <Select style={{ width: "270px" }}
                                  onChange={this.setPositionFilter}
                                  allowClear
                                  disabled={this.readOnly||this.state.disabled}>
                                  {this.state.triggeredPositions.map(position => (
                                    <Select.Option key={position.id} value={position.id} dataRef={position}>
                                      {position.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="职务">
                              {this.props.form.getFieldDecorator("business_name", {
                                rules: [{ required: false }],
                                initialValue: this.state.tab0.business_name
                              })(<Input disabled style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left", display: "none" }} className="roster-right-content">
                            <Form.Item label="职级">
                              {this.props.form.getFieldDecorator("business_level", {
                                rules: [{ required: false }],
                                initialValue: this.state.tab0.business_level
                              })(<Input disabled style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="员工状态">
                              {this.props.form.getFieldDecorator("job_status", {
                                rules: [{ required: false }],
                                initialValue: this.state.tab0.job_status
                              })(
                                <Radio.Group disabled={this.state.employee_id.length != 0} multiple buttonStyle="solid">
                                  <Radio.Button value={4} style={{ width: "67px" }}>在职</Radio.Button>
                                  <Radio.Button value={3} style={{ width: "67px" }}>兼职</Radio.Button>
                                  <Radio.Button value={2} style={{ width: "67px" }}>试用</Radio.Button>
                                  <Radio.Button value={5} style={{ width: "67px" }}>离职</Radio.Button>
                                </Radio.Group>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="生日">
                              {this.props.form.getFieldDecorator("birthday", {
                                rules: [{ required: true, message: '请输入生日' }],
                                initialValue: this.state.tab0.birthday ? moment(this.state.tab0.birthday) : null
                              })(<DatePicker disabled={this.readOnly} style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="国籍">
                              {this.props.form.getFieldDecorator("nationality_id", {
                                rules: [{ required: true, message: '请选择国籍' }],
                                initialValue: this.state.tab0.nationality_id
                              })(
                                <Select style={{ width: "270px" }} disabled={this.readOnly} allowClear>
                                  {this.state.meta.nationalities.map(nation => (
                                    <Select.Option key={nation.Value} value={nation.Value}>{nation.Text}</Select.Option>
                                  ))}
                                </Select>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="籍贯">
                              {this.props.form.getFieldDecorator("native_place", {
                                rules: [],
                                initialValue: this.state.tab0.native_place
                              })(
                              // <Input disabled={this.readOnly} style={{ width: "270px" }} />
                              <Select style={{ width: "270px" }} disabled={this.readOnly} allowClear
                              showSearch
                              filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }>
                                <Select.Option key={'上海市'} value={'上海市'}>{'上海市'}</Select.Option>
                                <Select.Option key={'北京市'} value={'北京市'}>{'北京市'}</Select.Option>
                                <Select.Option key={'天津市'} value={'天津市'}>{'天津市'}</Select.Option>
                                <Select.Option key={'重庆市'} value={'重庆市'}>{'重庆市'}</Select.Option>

                                <Select.Option key={'黑龙江省'} value={'黑龙江省'}>{'黑龙江省'}</Select.Option>
                                <Select.Option key={'吉林省'} value={'吉林省'}>{'吉林省'}</Select.Option>
                                <Select.Option key={'辽宁省'} value={'辽宁省'}>{'辽宁省'}</Select.Option>
                                <Select.Option key={'河北省'} value={'河北省'}>{'河北省'}</Select.Option>

                                <Select.Option key={'山西省'} value={'山西省'}>{'山西省'}</Select.Option>
                                <Select.Option key={'浙江省'} value={'浙江省'}>{'浙江省'}</Select.Option>
                                <Select.Option key={'江苏省'} value={'江苏省'}>{'江苏省'}</Select.Option>
                                <Select.Option key={'安徽省'} value={'安徽省'}>{'安徽省'}</Select.Option>

                                <Select.Option key={'福建省'} value={'福建省'}>{'福建省'}</Select.Option>
                                <Select.Option key={'江西省'} value={'江西省'}>{'江西省'}</Select.Option>
                                <Select.Option key={'山东省'} value={'山东省'}>{'山东省'}</Select.Option>
                                <Select.Option key={'河南省'} value={'河南省'}>{'河南省'}</Select.Option>
                                <Select.Option key={'湖北省'} value={'湖北省'}>{'湖北省'}</Select.Option>
                                <Select.Option key={'湖南省'} value={'湖南省'}>{'湖南省'}</Select.Option>
                                <Select.Option key={'广东省'} value={'广东省'}>{'广东省'}</Select.Option>
                                <Select.Option key={'海南省'} value={'海南省'}>{'海南省'}</Select.Option>

                                <Select.Option key={'四川省'} value={'四川省'}>{'四川省'}</Select.Option>
                                <Select.Option key={'贵州省'} value={'贵州省'}>{'贵州省'}</Select.Option>
                                <Select.Option key={'云南省'} value={'云南省'}>{'云南省'}</Select.Option>
                                <Select.Option key={'陕西省'} value={'陕西省'}>{'陕西省'}</Select.Option>
                                <Select.Option key={'甘肃省'} value={'甘肃省'}>{'甘肃省 '}</Select.Option>
                                <Select.Option key={'青海省'} value={'青海省'}>{'青海省'}</Select.Option>
                                <Select.Option key={'台湾省'} value={'台湾省'}>{'台湾省'}</Select.Option>

                                <Select.Option key={'内蒙古自治区'} value={'内蒙古自治区'}>{'内蒙古自治区'}</Select.Option>
                                <Select.Option key={'新疆维吾尔自治区'} value={'新疆维吾尔自治区'}>{'新疆维吾尔自治区'}</Select.Option>
                                <Select.Option key={'广西壮族自治区'} value={'广西壮族自治区'}>{'广西壮族自治区'}</Select.Option>
                                <Select.Option key={'宁夏回族自治区'} value={'宁夏回族自治区'}>{'宁夏回族自治区'}</Select.Option>
                                <Select.Option key={'西藏自治区'} value={'西藏自治区'}>{'西藏自治区'}</Select.Option>
                                <Select.Option key={'香港特别行政区'} value={'香港特别行政区'}>{'香港特别行政区 '}</Select.Option>
                                <Select.Option key={'澳门特别行政区'} value={'澳门特别行政区'}>{'澳门特别行政区'}</Select.Option>
                                <Select.Option key={'境外'} value={'境外'}>{'境外'}</Select.Option>
                            </Select>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="证件类型">
                              {this.props.form.getFieldDecorator("id_type_id", {
                                rules: [{ required: true, message: '请输入证件类型' }],
                                initialValue: this.state.tab0.id_type_id
                              })(
                                <Select style={{ width: "270px" }} disabled={this.readOnly} allowClear>
                                  {this.state.meta.id_types.map(id_type => (
                                    <Select.Option key={id_type.Value} value={id_type.Value}>{id_type.Text}</Select.Option>
                                  ))}
                                </Select>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="证件号">
                              {this.props.form.getFieldDecorator("id_number", {
                                rules: [{ required: true, message: '请输入证件号' }],
                                initialValue: this.state.tab0.id_number
                              })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="证件姓名">
                              {this.props.form.getFieldDecorator("id_name", {
                                rules: [{ required: true, message: '请输入证件姓名' }],
                                initialValue: this.state.tab0.id_name
                              })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div>

                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="婚姻状况">
                              {this.props.form.getFieldDecorator("marital_status_id", {
                                rules: [],
                                initialValue: this.state.tab0.marital_status_id
                              })(
                                <Select style={{ width: "270px" }} disabled={this.readOnly} allowClear>
                                  {this.state.meta.marital_statuses.map(marry => (
                                    <Select.Option key={marry.Value} value={marry.Value}>{marry.Text}</Select.Option>
                                  ))}
                                </Select>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="手机号">
                              {this.props.form.getFieldDecorator("cell_phone", {
                                rules: [{
                                  required: true,
                                  message: '请输入手机号'
                                }, {
                                  pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
                                  message: "请输入合法手机号"
                                }
                                ],
                                initialValue: this.state.tab0.cell_phone
                              })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div>

                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="分机号">
                              {this.props.form.getFieldDecorator("extension_number", {
                                rules: [],
                                initialValue: this.state.tab0.extension_number
                              })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="邮箱">
                              {this.props.form.getFieldDecorator("email", {
                                rules: [{
                                  required: true,
                                  message: '请输入邮箱'
                                }, {
                                  pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                                  message: "请输入合法邮箱"
                                }
                                ],
                                initialValue: this.state.tab0.email
                              })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="司龄">
                              {this.props.form.getFieldDecorator("work_year", {
                                rules: [],
                                initialValue: this.state.tab0.work_year
                              })(<Input disabled={true} style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="语言">
                              {this.props.form.getFieldDecorator("language", {
                                rules: [{ required: true, message: '请输入语言' }],
                                initialValue: this.state.tab0.language
                              })(
                                <Select style={{ width: "270px" }} disabled={this.readOnly} allowClear>
                                  <Select.Option key='汉语' value='汉语'>{'汉语'}</Select.Option>
                                  <Select.Option key='英语' value='英语'>{'英语'}</Select.Option>
                                </Select>
                              )}
                            </Form.Item>
                          </div>






                          <div style={{ padding: "0px 15px 15px 0px", float: "left", display: "none" }} className="roster-right-content">
                            <Form.Item label="合同类型">
                              {this.props.form.getFieldDecorator("contract_type", {
                                rules: [{ required: false }],
                                initialValue: this.state.tab0.contract_type_name
                              })(<Input disabled style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="工作地点">
                              {this.props.form.getFieldDecorator("work_place", {
                                rules: [{ required: true, message: "请输入工作地点" }],
                                initialValue: this.state.tab0.work_place
                              })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="员工类型">
                              {this.props.form.getFieldDecorator("nationality", {
                                rules: [{ required: true, message: '请选择类型' }],
                                initialValue: this.state.tab0.nationality
                              })(
                                <Select style={{ width: "270px" }} disabled={this.readOnly||this.state.disabled} allowClear>
                                  <Select.Option key='1' value={1}>{'中籍'}</Select.Option>
                                  <Select.Option key='2' value={2}>{'外籍'}</Select.Option>
                                </Select>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="育儿假天数">
                              {this.props.form.getFieldDecorator("parental_days", {
                                rules: [],
                                initialValue: this.state.tab0.parental_days
                              })(<InputNumber style={{ width: "270px" }} disabled={this.readOnly||this.state.disabled}/>)}
                            </Form.Item>
                          </div>
                          {/* <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                            <Form.Item label="联系地址">
                              {this.props.form.getFieldDecorator("contact_address", {
                                rules: [{ required: true, message: '请输入联系地址' }],
                                initialValue: this.state.tab0.contact_address
                              })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                            </Form.Item>
                          </div> */}





                        </Form>
                      </div>
                      <div style={{ clear: "both" }}></div>
                    </div>
                  </div>
                </div>}
            </Tabs.TabPane>
            <Tabs.TabPane tab="用户详情 User details" key="tab1" disabled={!this.state.employee_id}>
              {"loaded" === this.state.tab1Status && "tab1" === this.state.tabIndex &&
                <div>
                  {!this.readOnly &&
                    <div>
                      <Button type="primary" onClick={this.submitDetailInformation}>
                        <Icon type="save" theme="outlined" />
                        <span>保存信息</span>
                      </Button>
                    </div>}
                  <div style={{ overflowX: "auto" }}>
                    <div style={{ width: "1155px", margin: "15px 0px 0px" }}>
                      <Form layout="inline">
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="紧急联系人">
                            {this.props.form.getFieldDecorator("emergency_contact_name", {
                              rules: [],
                              initialValue: this.state.tab1.emergency_contact_name
                            })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div>
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="紧急联系人关系">
                            {this.props.form.getFieldDecorator("emergency_contact_relate", {
                              rules: [],
                              initialValue: this.state.tab1.emergency_contact_relate
                            })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div>
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="紧急联系电话">
                            {this.props.form.getFieldDecorator("emergency_contact_phone", {
                              rules: [],
                              initialValue: this.state.tab1.emergency_contact_phone
                            })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div>
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="户籍性质">
                            {this.props.form.getFieldDecorator("family_register", {
                              rules: [],
                              initialValue: this.state.tab1.family_register
                            })(
                              <Select style={{ width: "270px" }} disabled={this.readOnly} allowClear>
                                <Select.Option key='1' value={1}>{'城镇'}</Select.Option>
                                <Select.Option key='0' value={0}>{'非城镇'}</Select.Option>

                              </Select>
                            )}
                          </Form.Item>
                        </div>
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="户籍地址">
                            {this.props.form.getFieldDecorator("household_address", {
                              rules: [],
                              initialValue: this.state.tab1.household_address
                            })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div>
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="在沪住址">
                            {this.props.form.getFieldDecorator("live_address", {
                              rules: [],
                              initialValue: this.state.tab1.live_address
                            })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div>
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="民族">
                            {this.props.form.getFieldDecorator("nation_id", {
                              rules: [],
                              initialValue: this.state.tab1.nation_id
                            })(
                              <Select style={{ width: "270px" }} disabled={this.readOnly} allowClear>
                                {this.state.meta.nations.map(nation => (
                                  <Select.Option key={nation.Value} value={nation.Value}>{nation.Text}</Select.Option>
                                ))}
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="政治面貌">
                            {this.props.form.getFieldDecorator("political_status", {
                              rules: [],
                              initialValue: this.state.tab1.political_status
                            })(
                              <Select style={{ width: "270px" }} disabled={this.readOnly} allowClear>
                                {this.state.meta.political_statuses.map(pilitical => (
                                  <Select.Option key={pilitical.Value} value={pilitical.Value}>{pilitical.Text}</Select.Option>
                                ))}
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="学历">
                            {this.props.form.getFieldDecorator("qualification_id", {
                              rules: [],
                              initialValue: this.state.tab1.qualification_id
                            })(
                              <Select style={{ width: "270px" }} disabled={this.readOnly} allowClear>
                                {this.state.meta.Qualifications.map(qualifi => (
                                  <Select.Option key={qualifi.Value} value={qualifi.Value}>{qualifi.Text}</Select.Option>
                                ))}
                              </Select>
                            )}
                          </Form.Item>
                        </div>

                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="年龄">
                            {this.props.form.getFieldDecorator("age", {
                              rules: [],
                              initialValue: this.state.tab1.age
                            })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div>
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="星座">
                            {this.props.form.getFieldDecorator("constellation", {
                              rules: [],
                              initialValue: this.state.tab1.constellation
                            })(
                              <Select style={{ width: "270px" }} disabled={this.readOnly} allowClear>
                                <Select.Option key='1' value='白羊座'>{'白羊座'}</Select.Option>
                                <Select.Option key='2' value='金牛座'>{'金牛座'}</Select.Option>
                                <Select.Option key='3' value='双子座'>{'双子座'}</Select.Option>
                                <Select.Option key='4' value='巨蟹座'>{'巨蟹座'}</Select.Option>
                                <Select.Option key='5' value='狮子座'>{'狮子座'}</Select.Option>
                                <Select.Option key='6' value='处女座'>{'处女座'}</Select.Option>
                                <Select.Option key='7' value='天秤座'>{'天秤座'}</Select.Option>
                                <Select.Option key='8' value='天蝎座'>{'天蝎座'}</Select.Option>
                                <Select.Option key='9' value='射手座'>{'射手座'}</Select.Option>
                                <Select.Option key='10' value='摩羯座'>{'摩羯座'}</Select.Option>
                                <Select.Option key='11' value='水瓶座'>{'水瓶座'}</Select.Option>
                                <Select.Option key='12' value='双鱼座'>{'双鱼座'}</Select.Option>
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="银行开户行">
                            {this.props.form.getFieldDecorator("bank_name", {
                              rules: [],
                              initialValue: this.state.tab1.bank_name
                            })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div>
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="银行卡号">
                            {this.props.form.getFieldDecorator("bank_number", {
                              rules: [],
                              initialValue: this.state.tab1.bank_number
                            })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div>
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="企业微信">
                            {this.props.form.getFieldDecorator("wechat_identity", {
                              rules: [],
                              initialValue: this.state.tab1.wechat_identity
                            })(<Input disabled={this.readOnly||this.state.disabled} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div>

                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="爱好特长">
                            {this.props.form.getFieldDecorator("special_skills", {
                              rules: [],
                              initialValue: this.state.tab1.special_skills
                            })(<Input disabled={this.readOnly} style={{ width: "1040px" }} rows={6}></Input>)}
                          </Form.Item>
                        </div>

                        {/* <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="工龄">
                            {this.props.form.getFieldDecorator("service_length_history", {
                              rules: [],
                              initialValue: this.state.tab1.service_length_history
                            })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div>
                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="在职工龄">
                            {this.props.form.getFieldDecorator("service_length", {
                              rules: [],
                              initialValue: this.state.tab1.service_length
                            })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div> */}





                        {/* <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="QQ">
                            {this.props.form.getFieldDecorator("qq", {
                              rules: [],
                              initialValue: this.state.tab1.qq
                            })(<Input disabled={this.readOnly} style={{ width: "270px" }} />)}
                          </Form.Item>
                        </div> */}







                        <div style={{ padding: "0px 15px 15px 0px", float: "left" }} className="roster-right-content">
                          <Form.Item label="备注">
                            {this.props.form.getFieldDecorator("remarks", {
                              rules: [],
                              initialValue: this.state.tab1.remarks
                            })(<Input.TextArea disabled={this.readOnly} style={{ width: "1040px" }} rows={6}></Input.TextArea>)}
                          </Form.Item>
                        </div>
                      </Form>
                      <div style={{ clear: "both" }}></div>
                    </div>
                  </div>
                </div>}
            </Tabs.TabPane>

            <Tabs.TabPane tab="子女信息 Child details" key="tabc" disabled={!this.state.employee_id}>
              {"loaded" === this.state.tabcStatus && "tabc" === this.state.tabIndex &&
                <div>
                  {!this.readOnly  &&
                    <div>
                      <Button type="primary" onClick={this.createChildDetail}>
                        <Icon type="plus-circle-o" theme="outlined" />
                        <span>新增子女信息</span>
                      </Button>
                    </div>}
                  <div style={{ overflowX: "auto" }}>
                    {0 === this.state.tabc.childs.length &&
                      <div style={{ margin: "15px 0px 0px", textAlign: "center", width: "1140px", color: "#8e8e8e" }}>
                        <Divider style={{ margin: "0px 0px 15px" }} />
                        <span>暂无数据</span>
                      </div>}
                    <ul style={{ padding: "0px", margin: "15px 0px 0px" }}>
                      {this.state.tabc.childs.map((child, index) => (
                        <li key={index} style={{ margin: "0px 0px 15px" }}>
                          <Card title={"子女信息" + (index + 1)} style={{ width: "900px" }}
                            extra={!this.readOnly  &&
                              <span>
                                {!child.id && <Tag color="volcano">未保存</Tag>}
                                <a style={{ margin: "0px 10px" }} onClick={this.deleteChild.bind(this, index)}>删除</a>
                                <a style={{ margin: "0px 10px" }} onClick={this.submitChild.bind(this, index)}>保存</a>
                              </span>}>
                            <div style={{ height: "40px", lineHeight: "40px" }}>
                              <Row>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }}>
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>中文名: &nbsp;&nbsp;</span>
                                  </span>
                                  <Input disabled={this.readOnly} style={{ width: "270px" }} value={child.name}
                                    onChange={this.changeChild.bind(this, index, "name")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span>英文名: &nbsp;&nbsp;</span>
                                  </span>
                                  <Input disabled={this.readOnly} style={{ width: "270px" }} value={child.english_name}
                                    onChange={this.changeChild.bind(this, index, "english_name")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span>出生年月: &nbsp;&nbsp;</span>
                                  </span>
                                  <DatePicker disabled={this.readOnly} style={{ width: "270px" }}
                                    value={child.birthday ? moment(child.birthday) : null}
                                    onChange={this.changeChildBirthday.bind(this, index, "birthday")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span>性别: &nbsp;&nbsp;</span>
                                  </span>
                                  <Radio.Group disabled={this.readOnly} buttonStyle="solid" value={child.gender} onChange={this.changeChild.bind(this, index, "gender")} style={{ width: "270px" }}>
                                    <Radio.Button value={1}>男</Radio.Button>
                                    <Radio.Button value={0}>女</Radio.Button>
                                  </Radio.Group>
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span>年龄: &nbsp;&nbsp;</span>
                                  </span>
                                  <Input disabled={this.readOnly} style={{ width: "270px" }} value={child.age}
                                    onChange={this.changeChild.bind(this, index, "age")} />
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>}
            </Tabs.TabPane>
            <Tabs.TabPane tab="合同信息 Contract info" key="tab2" disabled={!this.state.employee_id}>
              {"loaded" === this.state.tab2Status && "tab2" === this.state.tabIndex &&
                <div>
                  {!this.readOnly  &&
                    <div>
                      <Button type="primary" onClick={this.createContractItem}>
                        <Icon type="plus-circle-o" theme="outlined" />
                        <span>添加合同信息</span>
                      </Button>
                    </div>}
                  <div style={{ overflowX: "auto" }}>
                    {0 === this.state.tab2.contracts.length &&
                      <div style={{ margin: "15px 0px 0px", textAlign: "center", width: "1140px", color: "#8e8e8e" }}>
                        <Divider style={{ margin: "0px 0px 15px" }} />
                        <span>暂无数据</span>
                      </div>}
                    <ul style={{ padding: "0px", margin: "15px 0px 0px", width: "900px" }}>
                      {this.state.tab2.contracts.map((contract, index) => (
                        <li key={index} style={{ margin: "0px 0px 15px" }}>
                          <Card title={"合同记录" + (index + 1)}
                            extra={!this.readOnly  &&
                              <span>
                                {!contract.id && <Tag color="volcano">未保存</Tag>}
                                <a style={{ margin: "0px 10px" }} onClick={this.deleteContract.bind(this, index)}>删除</a>
                                <a style={{ margin: "0px 10px" }} onClick={this.submitContract.bind(this, index)}>保存</a>
                              </span>}>
                            <div style={{ height: "40px", lineHeight: "40px" }}>
                              <Row>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }}>
                                  <span>合同类型:&nbsp;&nbsp;</span>
                                  <Radio.Group disabled={this.readOnly} value={contract.type_id} style={{ width: "220px" }}
                                    onChange={this.changeContract.bind(this, index, "type_id")}>
                                    {this.state.tab2.contract_types.map((type, index) => (
                                      <Radio.Button value={type.Value} key={index}>{type.Text}</Radio.Button>
                                    ))}
                                  </Radio.Group>
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }}>
                                  <span>签订公司:&nbsp;&nbsp;</span>
                                  <Select style={{ width: "220px" }} value={contract.signed_company} disabled={this.readOnly} allowClear
                                   onChange={this.changeContract.bind(this, index, "signed_company")}>
                                  <Select.Option key='上海长颈鹿培训学校有限公司' value='上海长颈鹿培训学校有限公司'>{'上海长颈鹿培训学校有限公司'}</Select.Option>
                                  <Select.Option key='上海徐汇区长颈鹿培训中心' value='上海徐汇区长颈鹿培训中心'>{'上海徐汇区长颈鹿培训中心'}</Select.Option>
                                    <Select.Option key='上海长颈鹿投资有限公司' value='上海长颈鹿投资有限公司'>{'上海长颈鹿投资有限公司'}</Select.Option>
                                    <Select.Option key='上海长颈鹿美育文化艺术有限公司' value='上海长颈鹿美育文化艺术有限公司'>{'上海长颈鹿美育文化艺术有限公司'}</Select.Option>
                                </Select>
                                </Col>
                              </Row>
                            </div>
                            <div style={{ height: "40px", lineHeight: "40px" }}>
                              <Row>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }}>
                                  <span>开始时间:&nbsp;&nbsp;</span>
                                  <DatePicker disabled={this.readOnly} style={{ width: "220px" }}
                                    value={contract.start_date ? moment(contract.start_date) : null}
                                    onChange={this.changeContractDate.bind(this, index, "start_date")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }}>
                                  <span>截至时间:&nbsp;&nbsp;</span>
                                  <DatePicker disabled={this.readOnly} style={{ width: "220px" }}
                                    value={contract.end_date ? moment(contract.end_date) : null}
                                    onChange={this.changeContractDate.bind(this, index, "end_date")} />
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>}
            </Tabs.TabPane>
            <Tabs.TabPane tab="教育信息 Education info" key="tab3" disabled={!this.state.employee_id}>
              {"loaded" === this.state.tab3Status && "tab3" === this.state.tabIndex &&
                <div>
                  {!this.readOnly  &&
                    <div>
                      <Button type="primary" onClick={this.createEducationItem}>
                        <Icon type="plus-circle-o" theme="outlined" />
                        <span>新增教育信息</span>
                      </Button>
                    </div>}
                  <div style={{ overflowX: "auto" }}>
                    {0 === this.state.tab3.educations.length &&
                      <div style={{ margin: "15px 0px 0px", textAlign: "center", width: "1140px", color: "#8e8e8e" }}>
                        <Divider style={{ margin: "0px 0px 15px" }} />
                        <span>暂无数据</span>
                      </div>}
                    <ul style={{ padding: "0px", margin: "15px 0px 0px" }}>
                      {this.state.tab3.educations.map((education, index) => (
                        <li key={index} style={{ margin: "0px 0px 15px" }}>
                          <Card title={"教育信息" + (index + 1)} style={{ width: "900px" }}
                            extra={!this.readOnly  &&
                              <span>
                                {!education.id && <Tag color="volcano">未保存</Tag>}
                                <a style={{ margin: "0px 10px" }} onClick={this.deleteEducation.bind(this, index)}>删除</a>
                                <a style={{ margin: "0px 10px" }} onClick={this.submitEducation.bind(this, index)}>保存</a>
                              </span>}>
                            <div style={{ height: "40px", lineHeight: "40px" }}>
                              <Row>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }}>
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>学校名称: &nbsp;&nbsp;</span>
                                  </span>
                                  <Input disabled={this.readOnly} style={{ width: "270px" }} value={education.school_name}
                                    onChange={this.changeEducation.bind(this, index, "school_name")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>专业名称: &nbsp;&nbsp;</span>
                                  </span>
                                  <Input disabled={this.readOnly} style={{ width: "270px" }} value={education.major}
                                    onChange={this.changeEducation.bind(this, index, "major")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>学历: &nbsp;&nbsp;</span>
                                  </span>
                                  <Input disabled={this.readOnly} style={{ width: "270px" }} value={education.education_experience}
                                    onChange={this.changeEducation.bind(this, index, "education_experience")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>是否取得学位: &nbsp;&nbsp;</span>
                                  </span>
                                  <Radio.Group disabled={this.readOnly} buttonStyle="solid" value={education.get_degree}
                                    onChange={this.changeEducation.bind(this, index, "get_degree")}>
                                    <Radio.Button value={true}>是</Radio.Button>
                                    <Radio.Button value={false}>否</Radio.Button>
                                  </Radio.Group>
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>开始日期: &nbsp;&nbsp;</span>
                                  </span>
                                  <DatePicker disabled={this.readOnly} style={{ width: "270px" }}
                                    value={education.entry_date ? moment(education.entry_date) : null}
                                    onChange={this.changeEducationDate.bind(this, index, "entry_date")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>结束日期: &nbsp;&nbsp;</span>
                                  </span>
                                  <DatePicker disabled={this.readOnly} style={{ width: "270px" }}
                                    value={education.completion_date ? moment(education.completion_date) : null}
                                    onChange={this.changeEducationDate.bind(this, index, "completion_date")} />
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>}
            </Tabs.TabPane>
            <Tabs.TabPane tab="工作经历 Work experience" key="tab4" disabled={!this.state.employee_id}>
              {"loaded" === this.state.tab4Status && "tab4" === this.state.tabIndex &&
                <div>
                  {!this.readOnly  &&
                    <div>
                      <Button type="primary" onClick={this.createExperienceItem}>
                        <Icon type="plus-circle-o" theme="outlined" />
                        <span>新增工作经历</span>
                      </Button>
                    </div>}
                  <div style={{ overflowX: "auto" }}>
                    {0 === this.state.tab4.experiences.length &&
                      <div style={{ margin: "15px 0px 0px", textAlign: "center", width: "1140px", color: "#8e8e8e" }}>
                        <Divider style={{ margin: "0px 0px 15px" }} />
                        <span>暂无数据</span>
                      </div>}
                    <ul style={{ padding: "0px", margin: "15px 0px 0px" }}>
                      {this.state.tab4.experiences.map((experience, index) => (
                        <li key={index} style={{ margin: "0px 0px 15px" }}>
                          <Card title={"工作经历" + (index + 1)} style={{ width: "900px" }}
                            extra={!this.readOnly &&
                              <span>
                                {!experience.id && <Tag color="volcano">未保存</Tag>}
                                <a style={{ margin: "0px 10px" }} onClick={this.deleteExperience.bind(this, index)}>删除</a>
                                <a style={{ margin: "0px 10px" }} onClick={this.submitExperience.bind(this, index)}>保存</a>
                              </span>}>
                            <div style={{ height: "40px", lineHeight: "40px" }}>
                              <Row>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }}>
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>公司名称: &nbsp;&nbsp;</span>
                                  </span>
                                  <Input disabled={this.readOnly} style={{ width: "270px" }} value={experience.company_name}
                                    onChange={this.changeExperience.bind(this, index, "company_name")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>担任职位: &nbsp;&nbsp;</span>
                                  </span>
                                  <Input disabled={this.readOnly} style={{ width: "270px" }} value={experience.position}
                                    onChange={this.changeExperience.bind(this, index, "position")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>入职日期: &nbsp;&nbsp;</span>
                                  </span>
                                  <DatePicker disabled={this.readOnly} style={{ width: "270px" }}
                                    value={experience.entry_date ? moment(experience.entry_date) : null}
                                    onChange={this.changeExperienceDate.bind(this, index, "entry_date")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>离职日期: &nbsp;&nbsp;</span>
                                  </span>
                                  <DatePicker disabled={this.readOnly} style={{ width: "270px" }}
                                    value={experience.leave_date ? moment(experience.leave_date) : null}
                                    onChange={this.changeExperienceDate.bind(this, index, "leave_date")} />
                                </Col>
                                <Col span={24} style={{ padding: "4px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right", height: "115px" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>职位描述: &nbsp;&nbsp;</span>
                                  </span>
                                  <Input.TextArea disabled={this.readOnly}
                                    style={{ width: "695px" }} value={experience.position_description}
                                    rows={5}
                                    onChange={this.changeExperience.bind(this, index, "position_description")}>
                                  </Input.TextArea>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>}
            </Tabs.TabPane>
            <Tabs.TabPane tab="个人足迹 Personal record" key="tab5" disabled={!this.state.employee_id}>
              {!this.readOnly&&
                <div>
                  <Button type="primary" onClick={this.createRewardAndPunishment}>
                    <Icon type="plus-circle-o" theme="outlined" />
                    <span>新增奖惩记录</span>
                  </Button>
                </div>}
              {"loaded" === this.state.tab5Status && "tab5" === this.state.tabIndex &&
                <div style={{ padding: "0px", margin: "15px 0px 0px", width: "1100px" }}>
                  <Table columns={this.footmarkColumn}
                    dataSource={this.state.tab5.Data}
                    rowKey={(record, index) => index}
                    scroll={{ x: "1000px" }}
                    pagination={false}
                    onChange={this.setFootmarkPageFilter} />
                </div>}
            </Tabs.TabPane>
            <Tabs.TabPane tab="员工证照 Work permit" key="tab6" disabled={!this.state.employee_id}>
              {"loaded" === this.state.tab6Status && "tab6" === this.state.tabIndex &&
                <div>
                  {!this.readOnly  &&
                    <div>
                      <Button type="primary" onClick={this.createCertificateItem}>
                        <Icon type="plus-circle-o" theme="outlined" />
                        <span>新增员工证照</span>
                      </Button>
                    </div>}
                  <div style={{ overflowX: "auto" }}>
                    {0 === this.state.tab6.certificates.length &&
                      <div style={{ margin: "15px 0px 0px", textAlign: "center", width: "950px", color: "#8e8e8e" }}>
                        <Divider style={{ margin: "0px 0px 15px" }} />
                        <span>暂无数据</span>
                      </div>}
                    <ul style={{ padding: "0px", margin: "15px 0px 0px", width: "950px", listStyle: "none" }}>
                      {this.state.tab6.certificates.map((certificate, index) => (
                        <li key={index} style={{ margin: "0px 0px 15px", padding: "0px 15px 0px 0px" }}>
                          <Card title={
                            <span>
                              <span>证照名称:&nbsp;&nbsp;</span>
                              <Input disabled={this.readOnly} style={{ width: "240px" }}
                                value={certificate.name}
                                onChange={this.changeCertificate.bind(this, index, "name")} />
                            </span>}
                            extra={!this.readOnly &&
                              <span>
                                {!certificate.id && <Tag color="volcano">未保存</Tag>}
                                <a style={{ margin: "0px 10px" }} onClick={this.deleteCertificate.bind(this, index)}>删除</a>
                                <a style={{ margin: "0px 10px" }} onClick={this.submitCertificate.bind(this, index)}>保存</a>
                              </span>}>
                            <div>
                              <Row>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px", lineHeight: "40px" }}>
                                  <span style={{ display: "inline-block", width: "100px" }}>证件类型:&nbsp;&nbsp;</span>
                                  <Select style={{ width: "240px" }} disabled={this.readOnly} allowClear
                                    value={certificate.type_id}
                                    onChange={this.changeCertificateData.bind(this, index, "type_id")}>
                                    {this.state.tab6.meta.id_types.map(id_type => (
                                      <Select.Option key={id_type.Value} value={id_type.Value}>{id_type.Text}</Select.Option>
                                    ))}
                                  </Select>
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px", lineHeight: "40px" }}>
                                  <span style={{ display: "inline-block", width: "100px" }}>证件编号:&nbsp;&nbsp;</span>
                                  <Input disabled={this.readOnly} style={{ width: "240px" }}
                                    value={certificate.serial_number}
                                    onChange={this.changeCertificate.bind(this, index, "serial_number")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px", lineHeight: "40px" }}>
                                  <span style={{ display: "inline-block", width: "100px" }}>发证机构:&nbsp;&nbsp;</span>
                                  <Input disabled={this.readOnly} style={{ width: "240px" }}
                                    value={certificate.issuing_organ}
                                    onChange={this.changeCertificate.bind(this, index, "issuing_organ")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px", lineHeight: "40px" }}>
                                  <span style={{ display: "inline-block", width: "100px" }}>发证日期:&nbsp;&nbsp;</span>
                                  <DatePicker disabled={this.readOnly} style={{ width: "240px" }}
                                    value={certificate.issuing_date ? moment(certificate.issuing_date) : null}
                                    onChange={this.changeCertificateDate.bind(this, index, "issuing_date")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px", lineHeight: "40px" }}>
                                  <span style={{ display: "inline-block", width: "100px" }}>备案日期:&nbsp;&nbsp;</span>
                                  <DatePicker disabled={this.readOnly} style={{ width: "240px" }}
                                    value={certificate.record_date ? moment(certificate.record_date) : null}
                                    onChange={this.changeCertificateDate.bind(this, index, "record_date")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px", lineHeight: "40px" }}>
                                  <span style={{ display: "inline-block", width: "100px" }}>到期日期:&nbsp;&nbsp;</span>
                                  <DatePicker disabled={this.readOnly} style={{ width: "240px" }}
                                    value={certificate.expire_date ? moment(certificate.expire_date) : null}
                                    onChange={this.changeCertificateDate.bind(this, index, "expire_date")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px", lineHeight: "40px" }}>
                                  <span style={{ display: "inline-block", width: "100px" }}>专业:&nbsp;&nbsp;</span>
                                  <Input disabled={this.readOnly} style={{ width: "240px" }}
                                    value={certificate.specialty}
                                    onChange={this.changeCertificate.bind(this, index, "specialty")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px", lineHeight: "40px" }}>
                                  <span style={{ display: "inline-block", width: "100px" }}>级别:&nbsp;&nbsp;</span>
                                  <Input disabled={this.readOnly} style={{ width: "240px" }}
                                    value={certificate.c_level}
                                    onChange={this.changeCertificate.bind(this, index, "c_level")} />
                                </Col>
                              </Row>
                              <div style={{ padding: "15px 0px 0px" }}>
                                <Upload multiple
                                  fileList={certificate.images.map(image => {
                                    return {
                                      ...image,
                                      url: image.photo_path
                                    }
                                  })}
                                  listType="picture-card"
                                  disabled={this.readOnly || this.state.isUploadingCertificateImage}
                                  beforeUpload={this.beforeUpload}
                                  customRequest={this.uploadCertificateImage.bind(this, index)}
                                  showUploadList={{
                                    showPreviewIcon: true,
                                    showRemoveIcon: !this.readOnly
                                  }}
                                  onPreview={this.previewCertificate}
                                  onRemove={this.removeCertificate.bind(this, index)}>
                                  {!this.readOnly && !this.state.disabled &&
                                    <div>
                                      <Icon type="plus" />
                                      <div style={{ margin: "8px 0px 0px", color: "#999999" }}>上传图片</div>
                                    </div>}
                                </Upload>
                                <Modal visible={this.state.certificatePreviewVisiable}
                                  footer={null}
                                  onCancel={this.toggleCertificatePreviewModal}>
                                  <img alt="example" style={{ width: '100%' }} src={this.state.certificatePreviewImage} />
                                </Modal>
                              </div>
                            </div>
                          </Card>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>}
            </Tabs.TabPane>
            <Tabs.TabPane tab="培训基金" key="tab7" disabled={!this.state.employee_id}>
              {"loaded" === this.state.tab7Status && "tab7" === this.state.tabIndex &&
                <div>
                  {!this.readOnly && !this.state.disabled &&
                    <div>
                      <Button type="primary" onClick={this.createFoundationItem}>
                        <Icon type="plus-circle-o" theme="outlined" />
                        <span>新增培训基金</span>
                      </Button>
                    </div>}
                  <div style={{ overflowX: "auto" }}>
                    {0 === this.state.tab7.foundations.length &&
                      <div style={{ margin: "15px 0px 0px", textAlign: "center", width: "1140px", color: "#8e8e8e" }}>
                        <Divider style={{ margin: "0px 0px 15px" }} />
                        <span>暂无数据</span>
                      </div>}
                    <ul style={{ padding: "0px", margin: "15px 0px 0px" }}>
                      {this.state.tab7.foundations.map((foundation, index) => (
                        <li key={index} style={{ margin: "0px 0px 15px" }}>
                          <Card title={"培训基金" + (index + 1)} style={{ width: "900px" }}
                            extra={!this.readOnly &&
                              <span>
                                {!foundation.id && <Tag color="volcano">未保存</Tag>}
                                <a style={{ margin: "0px 10px" }} onClick={this.deleteFoundation.bind(this, index)}>删除</a>
                                <a style={{ margin: "0px 10px" }} onClick={this.submitFoundation.bind(this, index)}>保存</a>
                              </span>}>
                            <div style={{ height: "40px", lineHeight: "40px" }}>
                              <Row>
                              <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span> 培训项目: &nbsp;&nbsp;</span>
                                  </span>
                                  <InputNumber disabled={this.readOnly} style={{ width: "270px" }} value={foundation.service_length}
                                    onChange={this.changeFoundationData.bind(this, index, "service_length")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }}>
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>培训金额: &nbsp;&nbsp;</span>
                                  </span>
                                  <InputNumber disabled={this.readOnly} style={{ width: "270px" }} value={foundation.training_amount}
                                    onChange={this.changeFoundationData.bind(this, index, "training_amount")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>开始日期: &nbsp;&nbsp;</span>
                                  </span>
                                  <DatePicker disabled={this.readOnly} style={{ width: "270px" }}
                                    value={foundation.start_time ? moment(foundation.start_time) : null}
                                    onChange={this.changeFoundationDate.bind(this, index, "start_time")} />
                                </Col>
                                <Col span={12} style={{ padding: "0px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>结束日期: &nbsp;&nbsp;</span>
                                  </span>
                                  <DatePicker disabled={this.readOnly} style={{ width: "270px" }}
                                    value={foundation.end_time ? moment(foundation.end_time) : null}
                                    onChange={this.changeFoundationDate.bind(this, index, "end_time")} />
                                </Col>
                                <Col span={24} style={{ padding: "4px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>是否签订协议: &nbsp;&nbsp;</span>
                                  </span>
                                  <Radio.Group disabled={this.readOnly} buttonStyle="solid"
                                    value={foundation.approval_status}
                                    onChange={this.changeFoundation.bind(this, index, "approval_status")}>
                                    <Radio.Button value={1}>是</Radio.Button>
                                    <Radio.Button value={2}>否</Radio.Button>
                                  </Radio.Group>
                                </Col>
                                <Col span={24} style={{ padding: "4px 15px 0px 0px" }} className="roster-inner-content">
                                  <span style={{ display: "inline-block", width: "120px", textAlign: "right", height: "115px" }}>
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    <span>备注: &nbsp;&nbsp;</span>
                                  </span>
                                  <Input.TextArea disabled={this.readOnly}
                                    style={{ width: "695px" }} value={foundation.remarks}
                                    rows={5}
                                    onChange={this.changeFoundation.bind(this, index, "remarks")}>
                                  </Input.TextArea>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>}
            </Tabs.TabPane>
            <Tabs.TabPane tab="机票补助" key="tab8" disabled={!this.state.employee_id}>
              {"loaded" === this.state.tab8Status && "tab8" === this.state.tabIndex &&
                <div style={{ padding: "0px", margin: "15px 0px 0px", width: "1100px" }}>
                  <Table columns={this.airticketColumn}
                    dataSource={this.state.tab8.Data}
                    rowKey={record => record.id}
                    scroll={{ x: "1000px" }}
                    pagination={false}
                    onChange={this.setAirticketPageFilter} />
                </div>}
            </Tabs.TabPane>
            <Tabs.TabPane tab="住房补助" key="tab9" disabled={!this.state.employee_id}>
              {"loaded" === this.state.tab9Status && "tab9" === this.state.tabIndex &&
                <div style={{ padding: "0px", margin: "15px 0px 0px", width: "1100px" }}>
                  <Table columns={this.housingColumn}
                    dataSource={this.state.tab9.Data}
                    rowKey={record => record.id}
                    scroll={{ x: "1000px" }}
                    pagination={false}
                    onChange={this.setHousingPageFilter} />
                </div>}
            </Tabs.TabPane>
            <Tabs.TabPane tab="参保详情" key="taba" disabled={!this.state.employee_id}>
              {"loaded" === this.state.tabaStatus && "taba" === this.state.tabIndex &&
                <div>
                  {!this.readOnly && !this.state.disabled &&
                    <div>
                      <Button type="primary" onClick={this.submitInsureInformation}>
                        <Icon type="save" theme="outlined" />
                        <span>保存信息</span>
                      </Button>
                    </div>}
                  <div style={{ margin: "15px 0px 0px" }}>
                    <div style={{ height: "40px", lineHeight: "40px" }}>
                      <span style={{ display: "inline-block", width: "100px", textAlign: "right" }}>
                        <span style={{ color: "red" }}>*&nbsp;</span>
                        <span>社保基数: &nbsp;&nbsp;</span>
                      </span>
                      <Input style={{ width: "270px" }} disabled={this.readOnly}
                        value={this.state.taba.insurance.insure_base}
                        onChange={this.changeInsuranceSettings.bind(this, "insure_base")} />
                    </div>
                    <div style={{ height: "40px", lineHeight: "40px" }}>
                      <span style={{ display: "inline-block", width: "100px", textAlign: "right" }}>
                        <span style={{ color: "red" }}>*&nbsp;</span>
                        <span>公积金基数: &nbsp;&nbsp;</span>
                      </span>
                      <Input style={{ width: "270px" }} disabled={this.readOnly}
                        value={this.state.taba.insurance.fund_base}
                        onChange={this.changeInsuranceSettings.bind(this, "fund_base")} />
                    </div>
                    <div style={{ height: "40px", lineHeight: "40px" }}>
                      <span style={{ display: "inline-block", width: "100px", textAlign: "right" }}>
                        <span style={{ color: "red" }}>*&nbsp;</span>
                        <span>公积金账号: &nbsp;&nbsp;</span>
                      </span>
                      <InputNumber style={{ width: "270px" }} disabled={this.readOnly}
                        value={this.state.taba.insurance.fund_number}
                        onChange={this.changeInsurance.bind(this, "fund_number")} />
                    </div>
                  </div>
                </div>}
            </Tabs.TabPane>
            <Tabs.TabPane tab="假期信息" key="tabb" disabled={!this.state.employee_id}>
              {"loaded" === this.state.tabbStatus && "tabb" === this.state.tabIndex &&
                <div style={{ width: "1100px" }}>
                  <h4 style={{ marginBottom: "10px" }}>根据公司规定, 当年年假有效期为次年的3月31号. 调休, 因公调休的有效期为次月的月底. 过期清零.</h4>
                  <Table columns={this.holidayColumn}
                    dataSource={this.state.tabb.holiday}
                    rowKey={(record, index) => index}
                    scroll={{ x: "1000px" }}
                    pagination={false} />
                </div>}
            </Tabs.TabPane>

          </Tabs>
          {"unload" === this.state[this.state.tabIndex + "Status"] &&
            <div style={{ textAlign: 'center', margin: '100px 0px' }}>
              <Spin size="large" />
            </div>}
        </div>

        <Modal width="800px"
          visible={this.state.RewardAndPunishmentModal}
          title="新增奖惩记录"
          destroyOnClose={true}
          onCancel={this.closeRewardAndPunishmentModal}
          onOk={this.submitRewardAndPunishment.bind(this)}>
          <div style={{ textAlign: "center" }}>
            <Form className="login-form" layout="inline">
              <div className="position-form-item">
                <Form.Item label="类型">
                  {this.props.form.getFieldDecorator('employee_track_type', {
                    rules: [{ required: this.state.RewardAndPunishmentModal, message: '请选择类型' }],
                  })(<Select style={{ width: "400px" }} >
                    <Select.Option key={7} value={7}>奖励</Select.Option>
                    <Select.Option key={9} value={9}>惩罚</Select.Option>
                    <Select.Option key={9} value={10}>优秀员工</Select.Option>
                    <Select.Option key={9} value={11}>晋升</Select.Option>
                  </Select>)}
                </Form.Item>
              </div>

              <div className="position-form-item">
                <Form.Item label="时间">
                  {this.props.form.getFieldDecorator('employee_track_time', {
                    rules: [{ required: this.state.RewardAndPunishmentModal, message: '请输入时间' }],
                  })(<DatePicker placeholder="奖惩时间" style={{ width: "400px" }} />)}
                </Form.Item>
              </div>

              <div className="position-form-item" >
                <Form.Item label="内容">
                  {this.props.form.getFieldDecorator('description', {})
                    (<Input.TextArea style={{ width: "400px" }} rows="5"></Input.TextArea>)}
                </Form.Item>
              </div>
            </Form>
          </div>
        </Modal>

      </div>
    )
  }

  closeRewardAndPunishmentModal = () => {
    this.setState({ RewardAndPunishmentModal: false })
  }
  createRewardAndPunishment = () => {
    this.setState({ RewardAndPunishmentModal: true })
  }

  submitRewardAndPunishment = () => {
    this.props.form.validateFields((err, values) => {

      let posts = {}
      posts.employee_id = this.state.employee_id;
      posts.employee_track_time = values["employee_track_time"].format('YYYY-MM-DD');
      posts.description = values["description"]
      posts.employee_track_type = values["employee_track_type"]

      trackService.addRewardAndPunishment(posts, res => {
        this.realInitializePage[this.state.tabIndex]()
        message.success("新增成功");
        this.closeRewardAndPunishmentModal();

      });

    })
  }
}




// WEBPACK FOOTER //
// ./src/routes/EmployeeManagement/EmployeeDetail.js